<template>
	<div class="SortView" :class="modes.map((m) => `SortView--${m}`)">
		<div class="SortViewButton">
			<svg-view name="sort" />
		</div>
	</div>
</template>

<script>
export default {
	name: "SortView",
	props: {
		modes: { type: Array, default: () => [] },
	},
};
</script>

<style scoped lang="less">
@import "~styles/const.less";

@r: .SortView;

@{r} {
	position: absolute;
	top: 5px;
	right: -50px;
	z-index: 10;

	svg {
		width: 100%;
		height: 100%;
		fill: transparent;

		&:hover {
			opacity: .7;
		}
	}

	&Button {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: @color-white;
		width: 30px;
		height: 30px;
		border-radius: 50%;
		cursor: grab;
		transition: opacity .3s ease;
	}

	&--top {
		top: 55px;
	}

	&--center {
		top: 15px;
	}

	&--bottom {
		top: auto;
		bottom: 6px;
	}
}
</style>
